import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { IconNames } from 'src/app/_components/icons/icon-names';
import { SvgTemplateComponent } from 'src/app/_components/svg-template/svg-template.component';

export type FlaskCardData =
  | {
      kind: 'od';
      offset: number | null;
      factor: number | null;
      power: number | null;
      rSquared: number | null;
      temperature: number | null;
    }
  | {
      kind: 'oxygen';
      dphi: number | null;
      temperature: number | null;
      pressure: number | null;
      hasError: boolean | null;
    }
  | {
      kind: 'ph';
      slope: number | null;
      mVOffset: number | null;
      phCalFactor: number | null;
      phCalOffset: number | null;
      rSquared: number | null;
    }
  | {
      kind: 'sparging';
      slope: number | null;
      intercept: number | null;
      rSquared: number | null;
    };

@Component({
  selector: 'app-flask-card',
  templateUrl: './flask-card.component.html',
  styleUrl: './flask-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgTemplateComponent],
})
export class FlaskCardComponent {
  readonly flaskLabel = input.required<'A' | 'B' | 'C' | 'D'>();
  readonly data = input.required<FlaskCardData>();

  readonly flaskIcon = computed<IconNames>(() => {
    switch (this.flaskLabel()) {
      case 'A':
        return IconNames.FlaskA;
      case 'B':
        return IconNames.FlaskB;
      case 'C':
        return IconNames.FlaskC;
      case 'D':
        return IconNames.FlaskD;
    }
  });
}
